import { FC, useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { routes } from "../../../router";

type Props = {
  matchingRoute: string;
  callback: (isMatching: boolean) => void;
};

export const RouteObserver: FC<Props> = ({ matchingRoute, callback }) => {
  const location = useLocation();

  useEffect(() => {
    const matches = matchRoutes(routes, location.pathname);
    callback(!!matches?.find((match) => match.pathname === matchingRoute));
  }, [callback, location, matchingRoute]);

  return null;
};
